export const firstCharToUpperCaseHelper = (value: string) => {
  return [value.charAt(0).toUpperCase(), value.slice(1)].join('')
}
